<template>
  <div class="container">
    <div class="title-section">
      <h1>军校报考助手</h1>
      <p>选择你想了解的信息，获取最全面的高校招生数据和志愿填报指导</p>
    </div>

    <div class="grid-container">
      <!-- 历年录取分数线及排名 -->
      <router-link to="/growths" class="router-link">
        <button class="button-card">
          <div class="icon-circle blue-bg">
            <i class="fa fa-line-chart"></i>
          </div>
          <h3 class="button-title">历年录取分数及排名</h3>
          <p class="button-desc">查看各高校近年分数线趋势和排名变化</p>
        </button>
      </router-link>

      <!-- 招生信息 -->
      <router-link to="/require" class="router-link">
        <button class="button-card">
          <div class="icon-circle green-bg">
            <i class="fa fa-info-circle"></i>
          </div>
          <h3 class="button-title">招生信息</h3>
          <p class="button-desc">了解最新招生政策、专业设置和招生计划</p>
        </button>
      </router-link>
      <!-- 填报志愿 -->
      <router-link to="/test" class="router-link">
        <button class="button-card">
          <div class="icon-circle purple-bg">
            <i class="fa fa-calculator"></i>
          </div>
          <h3 class="button-title">志愿填报规划</h3>
          <p class="button-desc">个性化定制，智能推荐适合你的高校</p>
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Choose",
};
</script>
<style scoped>
/* 外层容器样式 */
.container {
  margin-top: 60px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  background: linear-gradient(to bottom right, #f9fafb, #dbeafe);
  padding: 1rem;
}

/* 标题区域样式 */
.title-section {
  text-align: center;
  margin-top: 0; /* 直接设置为 0 或其他较小值 */
  margin-bottom: 3rem;
}

.title-section h1 {
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 1rem;
}

.title-section p {
  color: #4b5563;
  font-size: 1.25rem;
  max-width: 64rem;
  margin: 0 auto;
}

/* 功能按钮网格布局 */
.grid-container {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 2rem;
  max-width: 80rem;
  width: 100%;
}

@media (min-width: 768px) {
  .grid-container {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

/* 按钮链接动画 */
.router-link {
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.router-link:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

/* 按钮基础样式 */
.button-card {
  width: 100%;
  height: 16rem;
  background-color: white;
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
  outline: none;
}

/* 图标背景圆圈样式 */
.icon-circle {
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.blue-bg {
  background-color: #dbeafe;
  color: #2563eb;
}

.green-bg {
  background-color: #dcfce7;
  color: #16a34a;
}

.purple-bg {
  background-color: #f3e8ff;
  color: #7c3aed;
}

/* 文字样式 */
.button-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
}

.button-desc {
  color: #4b5563;
  text-align: center;
}
</style>
